module.exports = __webpack_public_path__ + "img/cl-install-wifi.958b3911.png";